globalThis.appCustomerSpace = globalThis.appCustomerSpace || {};
appCustomerSpace.Modals = appCustomerSpace.Modals || {};
appCustomerSpace.Modals.Account = appCustomerSpace.Modals.Account || {};

appCustomerSpace.Modals.Account.BundledNeedDetections = (function(superClass) {

  utils.extend(BundledNeedDetections, superClass);

  function BundledNeedDetections() {
    return BundledNeedDetections.__super__.constructor.apply(this, arguments);
  }

  $.extend(BundledNeedDetections.prototype, {
    init: function() {
      this.initEvents();

      return BundledNeedDetections.__super__.init.apply(this, arguments);
    },
    initEvents: function(){
      var modal = this;
      var $modal = modal.$html;

      $modal.find('input[type=radio]').on('change', function(){
        if($modal.find('input[type="radio"]').not(':checked').length == $modal.find('input[type="radio"]').length/2){
          //all checked
          $modal.find(".btn-disabled").hide();
          $modal.find(".btn-not-disabled").show();
        }
      });
    }
  });

  return BundledNeedDetections;

})(appCustomerSpace.Modal);
